import script from "./DepositSection1.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositSection1.vue?vue&type=script&setup=true&lang=js"

import "./DepositSection1.vue?vue&type=style&index=0&id=86e8d0d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86e8d0d6"]])

export default __exports__